import React, { useRef, useState } from "react";
import { ControlledMenu, MenuButton, MenuItem, SubMenu, useHover } from "@szhsin/react-menu";
import cx from "classnames";
const { isEqual } = require("lodash");

const MenuItems = ({ value = [], onChange, menu }) => {
    const ref = useRef(null);
    const [isOpen, setOpen] = useState(false);
    const { anchorProps, hoverProps } = useHover(isOpen, setOpen);

    const handleSelect = (event, value) => {
        event?.stopPropagation?.();
        onChange?.(value);
        setOpen(false);
    };

    const drawSubMenu = (item, menuId) => {
        const arrId = [...menuId, item.value];

        return (
            <div
                key={item.value}
                onClick={(e) => {
                    handleSelect(e, arrId);
                }}
                className={cx(isEqual(arrId, value.slice(0, arrId.length)) ? "text-info" : "")}
            >
                <SubMenu label={item.label} gap={5}>
                    {item.children.map((_item) => {
                        if (_item.children?.length) {
                            return drawSubMenu(_item, arrId);
                        }
                        return (
                            <MenuItem
                                key={_item.value}
                                onClick={(e) => handleSelect(e.syntheticEvent, [...arrId, _item.value])}
                                className={cx(
                                    isEqual([...arrId, _item.value], value.slice(0, [...arrId, _item.value].length))
                                        ? "text-info"
                                        : ""
                                )}
                            >
                                {_item.label}
                            </MenuItem>
                        );
                    })}
                </SubMenu>
            </div>
        );
    };

    return (
        <>
            <div className="d-flex gap-3" ref={ref} {...anchorProps}>
                <MenuButton
                    className={cx(
                        "btn mega-menu-btn rounded-pill px-4 py-2 shadow",
                        (value.includes(menu.value) || (value.length === 0 && menu.value === "")) ? "btn-info" : "btn-muted"
                    )}
                    onClick={(e) => handleSelect(e, [menu.value])}
                >
                    {menu.label} {menu?.count && `(${menu?.count})`}
                </MenuButton>
            </div>
            {menu.children?.length > 0 && (
                <ControlledMenu
                    {...hoverProps}
                    anchorRef={ref}
                    state={isOpen ? "open" : "closed"}
                    onClose={() => setOpen(false)}
                    menuClassName={cx("mt-2")}
                >
                    {menu.children.map((item) => drawSubMenu(item, [menu.value]))}
                </ControlledMenu>
            )}
        </>
    );
};

export default MenuItems;
